export default __webpack_public_path__ + "static/media/(69).90651e63.jpg";